/* AMRAM DESIGN: accessibility toolbar. No libraries. Choices persist in localStorage ('ad-a11y').
   The display modes are plain classes on <html> (see assets/a11y.css); text size is applied per element,
   so the theme's px type scale keeps its proportions. */
(() => {
  const html = document.documentElement;
  const KEY = 'ad-a11y';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];

  const MODES = { contrast: 'a11y-contrast', gray: 'a11y-gray', links: 'a11y-links', font: 'a11y-font', still: 'a11y-still', cursor: 'a11y-cursor' };
  const STEPS = [0.9, 1, 1.1, 1.2, 1.3];
  const state = { fs: 1, contrast: false, gray: false, links: false, font: false, still: false, cursor: false };

  /* ---------- storage (private mode / blocked cookies must not break the page) ---------- */
  function load() {
    try {
      const s = JSON.parse(localStorage.getItem(KEY) || '{}') || {};
      Object.keys(state).forEach(k => { if (k === 'fs') { if (STEPS.includes(+s.fs)) state.fs = +s.fs; } else state[k] = !!s[k]; });
    } catch (_) { /* no storage: the toolbar still works for this visit */ }
  }
  function save() { try { localStorage.setItem(KEY, JSON.stringify(state)); } catch (_) {} }

  /* ---------- text size ---------- */
  const FS_SEL = 'p,span,a,li,button,input,textarea,select,label,legend,summary,small,b,strong,em,i,h1,h2,h3,h4,h5,h6,td,th,dt,dd,figcaption,blockquote,time,.display,.lead,.caps,.eyebrow';
  const base = new WeakMap();
  function applyFs() {
    const f = state.fs;
    html.toggleAttribute('data-a11y-zoom', f !== 1);
    $$(FS_SEL, document.body).forEach(el => {
      if (el.closest('[data-a11y]')) return; // the toolbar itself stays at its own size
      let b = base.get(el);
      if (b === undefined) { b = { px: parseFloat(getComputedStyle(el).fontSize) || 15, inline: el.style.fontSize }; base.set(el, b); }
      if (f === 1) { if (b.inline) el.style.fontSize = b.inline; else el.style.removeProperty('font-size'); }
      else el.style.fontSize = (b.px * f).toFixed(2) + 'px';
    });
    const out = $('[data-a11y-val]'); if (out) out.textContent = Math.round(f * 100) + '%';
    $$('button[data-a11y-fs]').forEach(b => { const n = +b.dataset.a11yFs; b.disabled = (n > 0 && f === STEPS[STEPS.length - 1]) || (n < 0 && f === STEPS[0]); });
  }

  /* ---------- stop animations: also stop every video ---------- */
  function applyStill() {
    const on = state.still;
    $$('video').forEach(v => {
      if (on) { if (!v.paused) v.dataset.a11yPlay = '1'; v.pause(); v.removeAttribute('autoplay'); }
      else if (v.dataset.a11yPlay) { delete v.dataset.a11yPlay; v.play().catch(() => {}); }
    });
    document.dispatchEvent(new CustomEvent('ad:still', { detail: { on } }));
  }
  // a video that appears later (reels hover, cart re-render) must not start either
  document.addEventListener('play', (e) => { if (state.still && e.target.tagName === 'VIDEO') e.target.pause(); }, true);

  /* ---------- apply everything ---------- */
  function apply() {
    Object.keys(MODES).forEach(k => html.classList.toggle(MODES[k], !!state[k]));
    $$('[data-a11y]').forEach(b => { if (b.dataset.a11y && b.hasAttribute('aria-pressed')) b.setAttribute('aria-pressed', state[b.dataset.a11y] ? 'true' : 'false'); });
    applyFs();
    applyStill();
  }

  /* ---------- panel ---------- */
  function boot() {
    const root = $('.a11y[data-a11y]'); if (!root) return;
    const btn = $('[data-a11y-toggle]', root), panel = $('#a11y-panel', root);
    const setOpen = (on) => {
      panel.hidden = !on;
      btn.setAttribute('aria-expanded', on ? 'true' : 'false');
      if (on) { const f = $('.a11y__item, a', panel); f && f.focus({ preventScroll: true }); }
    };
    btn.addEventListener('click', () => setOpen(panel.hidden));
    $('[data-a11y-close]', root).addEventListener('click', () => { setOpen(false); btn.focus({ preventScroll: true }); });
    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape' || panel.hidden) return;
      setOpen(false); btn.focus({ preventScroll: true });
    });
    document.addEventListener('click', (e) => { if (!panel.hidden && !e.target.closest('.a11y[data-a11y]')) setOpen(false); });

    root.addEventListener('click', (e) => {
      const mode = e.target.closest('button[data-a11y][aria-pressed]');
      if (mode) { const k = mode.dataset.a11y; state[k] = !state[k]; save(); apply(); return; }
      const fs = e.target.closest('button[data-a11y-fs]');
      if (fs) {
        const i = Math.max(0, Math.min(STEPS.length - 1, STEPS.indexOf(state.fs) + (+fs.dataset.a11yFs > 0 ? 1 : -1)));
        state.fs = STEPS[i]; save(); applyFs(); return;
      }
      if (e.target.closest('button[data-a11y-reset]')) {
        Object.keys(state).forEach(k => state[k] = k === 'fs' ? 1 : false);
        try { localStorage.removeItem(KEY); } catch (_) {}
        apply(); $$('video[data-a11y-play]').forEach(v => delete v.dataset.a11yPlay);
      }
    });

    load(); apply();
    // sections re-rendered by Shopify (or the cart drawer) need the text size re-applied
    document.addEventListener('shopify:section:load', () => { applyFs(); applyStill(); });
    window.ADa11y = { apply, state };
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
